import { render, staticRenderFns } from "./AndroidButton.vue?vue&type=template&id=5a6d2fc7&"
import script from "./AndroidButton.vue?vue&type=script&lang=js&"
export * from "./AndroidButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports